module.exports = __webpack_public_path__ + "static/media/james.16f27579.jpg";